<template>
  <router-view/>
</template>

<script setup>

</script>



<style scoped lang="scss">

</style>
